import React, { useState } from 'react';
import { toast } from 'sonner';
import { Gift, Loader2, Lock, ArrowRight } from 'lucide-react';
import { useAuth } from '../App';
import PasswordStrengthMeter, { evaluatePassword } from './PasswordStrengthMeter';

export default function CreateAccountPrompt({ name, email }) {
  const { user, register } = useAuth();
  const [pw, setPw] = useState('');
  const [busy, setBusy] = useState(false);
  const [exists, setExists] = useState(false);
  if (user) return null;
  const submit = async (e) => {
    e.preventDefault();
    if (!evaluatePassword(pw).isStrong) { toast.error('Please choose a stronger password'); return; }
    setBusy(true);
    try {
      await register(name || email, email, pw, true);
      toast.success('Account created! Check your inbox to verify your email.');
      window.location.href = '/portal';
    } catch (err) {
      const d = err.response?.data?.detail || '';
      if (/already/i.test(d)) setExists(true); else toast.error(d || 'Could not create account');
      setBusy(false);
    }
  };
  return (
    <div className="mt-6 text-left rounded-2xl border-2 border-[#1D4ED8]/30 bg-gradient-to-br from-blue-50 to-white p-5" data-testid="booking-create-account">
      <div className="flex items-center gap-2 text-[#1D4ED8] font-bold text-sm mb-1"><Gift size={16} /> Create your free member account</div>
      <p className="text-sm text-[#475569] mb-3">Your strategy action plan from David will be delivered in your member portal. Set a password to claim it. It's free.</p>
      {exists ? (
        <a href="/login" className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#1D4ED8] hover:underline" data-testid="booking-create-account-login">
          You already have an account. Log in <ArrowRight size={14} />
        </a>
      ) : (
        <form onSubmit={submit} className="space-y-2">
          <div className="text-xs text-[#64748B]">Email: <strong className="text-[#0A0F1C]">{email}</strong></div>
          <div className="relative">
            <Lock size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]" />
            <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Choose a password" required data-testid="booking-create-account-password"
              className="w-full border border-[#E2E8F0] rounded-lg pl-10 pr-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1D4ED8]" />
          </div>
          {pw && <PasswordStrengthMeter password={pw} showChecklist={false} testId="booking-create-account-strength" />}
          <button disabled={busy} data-testid="booking-create-account-submit"
            className="w-full inline-flex items-center justify-center gap-2 bg-[#1D4ED8] hover:bg-[#1E40AF] text-white font-semibold rounded-lg py-2.5 text-sm disabled:opacity-60">
            {busy ? <Loader2 size={15} className="animate-spin" /> : null} Create my free account
          </button>
          <p className="text-[11px] text-[#94A3B8]">By creating an account you agree to our <a href="/terms" className="underline">Terms</a> and <a href="/privacy" className="underline">Privacy Policy</a>.</p>
        </form>
      )}
    </div>
  );
}
